import { combineReducers } from "redux-immutable";

import SubscriptionProductsStateSlice from "../models/SubscriptionProductsStateSlice";

import subscriptionProducts from "./state/subscription-products";
import subscriptionProductsMetaReducer from "./state/meta";

const subscriptionProductsReducer = combineReducers(
  {
    subscriptionProducts,
    meta: subscriptionProductsMetaReducer
  },
  () => new SubscriptionProductsStateSlice() as any
);

export default subscriptionProductsReducer;
